document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#cart-count-mobile .disabled')) {
    document
      .querySelector('#cart-count-mobile .disabled')
      .addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()
      })
  }

  if (document.querySelectorAll('.search-field').length > 0) {
    document.querySelectorAll('.search-field').forEach(search => {
      search.addEventListener('keyup', function (e) {
        setTimeout(() => {
          if (
            document
              .querySelectorAll('predictive-search')[2]
              .getAttribute('open') == 'true'
          ) {
            document
              .querySelector('.header-mobile-buttons-wrapper')
              .querySelector('.buttons-wrapper')
              .querySelector('.links-wrapper').style.opacity = '0'
          } else {
            document
              .querySelector('.header-mobile-buttons-wrapper')
              .querySelector('.buttons-wrapper')
              .querySelector('.links-wrapper').style.opacity = '1'
          }
        }, 1000)
      })
    })
  }

  function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling)
  }

  document.addEventListener('rebuy:smartcart.show', event => {
    const cart = window.Rebuy.Cart;

    setTimeout(() => {
      let totalSavedPrice = 0;

      if (document.querySelector('.rebuy-cart__flyout-items')) {
        if (document.querySelector('.rebuy-cart__flyout-items').querySelectorAll('li.rebuy-cart__flyout-item').length > 0) {
          document
            .querySelector('.rebuy-cart__flyout-items')
            .querySelectorAll('li.rebuy-cart__flyout-item')
            .forEach((item, index) => {
              let product = window.Rebuy.SmartCart.items()[index].product;
              let cartProduct = window.Rebuy.SmartCart.items()[index];
              if (!product) return;
              let quantity;
              if (product.selected_variant) {
                quantity = product.selected_variant.inventory_quantity
              } else {
                quantity = product.quantity
              }
              if (Number(quantity) == Number(cartProduct.quantity) && product.product_type != "Gift Cards") {
                if (item.querySelector('.rebuy-cart__flyout-item-quantity-widget-button .fa-plus')) {
                  item.querySelector('.rebuy-cart__flyout-item-quantity-widget-button .fa-plus').parentNode.setAttribute('disabled', 'disabled');
                  item.querySelector('.rebuy-cart__flyout-item-quantity-widget-button .fa-plus').setAttribute('disabled', 'disabled');
                }
                if (item.querySelectorAll('.td-smartcart-only-one-text').length == 0 && item.querySelector('.rebuy-cart__flyout-item-quantity-widget')) {
                  let notification = document.createElement("div");
                  notification.classList.add('td-smartcart-only-one-text');
                  notification.innerHTML = "Only 1 left!";
                  item.querySelector('.rebuy-cart__flyout-item-quantity-widget').append(notification);
                }
              }
              if (
                item.querySelector('.rebuy-money.compare-at') &&
                item.querySelector('.rebuy-money.sale')
              ) {
                let itemCompareAt = Number(
                  item
                    .querySelectorAll('.rebuy-money.compare-at span')[1]
                    .innerHTML.split('$')[1]
                )
                let itemSale = Number(
                  item
                    .querySelectorAll('.rebuy-money.sale span')[1]
                    .innerHTML.split('$')[1]
                )
                let itemSavedPrice = Number(itemCompareAt - itemSale).toFixed(2)
                if (itemSavedPrice > 0) {
                  if (item.querySelector('.rebuy-money.saved')) {
                    item.querySelector('.rebuy-money.saved').innerHTML =
                      'Save $' + itemSavedPrice
                  } else {
                    let savePrice = document.createElement('span')
                    savePrice.classList.add('rebuy-money')
                    savePrice.classList.add('saved')
                    savePrice.innerHTML = 'Save $' + itemSavedPrice
                    item
                      .querySelector('.rebuy-cart__flyout-item-price')
                      .append(savePrice)
                  }
                  totalSavedPrice += Number(itemSavedPrice)
                }
              }
            })
        }
      }

      if (document.querySelector('#SmartCart_title')) {
        document.querySelector('#SmartCart_title').innerHTML = cart.cart.item_count > 0 ? 'Cart (' + cart.cart.item_count + ')' : 'Your cart is empty';
      }

      if (document.querySelector('#cart-count-mobile')) {
        let html =
          '<a href="javascript: void(0);" title="Cart" class="cart-count-mobile relative " role="button" aria-label="Cart"><span><span class="icon icon-bag"><svg height="24" width="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"><g><path fill-rule="evenodd" clip-rule="evenodd" d="M11.1429 1.71429C10.0062 1.71429 8.91613 2.16582 8.1124 2.96954C7.30867 3.77327 6.85714 4.86336 6.85714 6V6.85714H15.4286V6C15.4286 4.86336 14.977 3.77327 14.1733 2.96954C13.3696 2.16582 12.2795 1.71429 11.1429 1.71429ZM17.1429 6.85714V6C17.1429 4.4087 16.5107 2.88258 15.3855 1.75736C14.2603 0.632141 12.7342 0 11.1429 0C9.55156 0 8.02544 0.632141 6.90022 1.75736C5.775 2.88258 5.14286 4.4087 5.14286 6V6.85714H1.71429C1.25963 6.85714 0.823593 7.03776 0.502103 7.35925C0.180612 7.68074 0 8.11677 0 8.57143V20.1429C0 22.2362 1.76376 24 3.85714 24H18.4286C20.4967 24 22.2857 22.3281 22.2857 20.2098V8.57143C22.2857 8.11677 22.1051 7.68074 21.7836 7.35925C21.4621 7.03776 21.0261 6.85714 20.5714 6.85714H17.1429ZM1.71429 8.57143L1.71429 20.1429C1.71429 21.2895 2.71053 22.2857 3.85714 22.2857H18.4286C19.6005 22.2857 20.5714 21.3315 20.5714 20.2098V8.57143H1.71429Z" fill="#383838"></path></g></svg></span><span class="cartCountSelector cart-count bag-icon size-1">' + cart.cart.item_count + '</span></span></a>'
        document.querySelector('#cart-count-mobile').innerHTML = html;
      }

      if (document.querySelector('#cart-count-desktop')) {
        let html =
          '<a href="javascript: void(0);" title="Cart" class="cart-count-mobile relative " role="button" aria-label="Cart"><span><span class="icon icon-bag"><svg height="24" width="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"><g><path fill-rule="evenodd" clip-rule="evenodd" d="M11.1429 1.71429C10.0062 1.71429 8.91613 2.16582 8.1124 2.96954C7.30867 3.77327 6.85714 4.86336 6.85714 6V6.85714H15.4286V6C15.4286 4.86336 14.977 3.77327 14.1733 2.96954C13.3696 2.16582 12.2795 1.71429 11.1429 1.71429ZM17.1429 6.85714V6C17.1429 4.4087 16.5107 2.88258 15.3855 1.75736C14.2603 0.632141 12.7342 0 11.1429 0C9.55156 0 8.02544 0.632141 6.90022 1.75736C5.775 2.88258 5.14286 4.4087 5.14286 6V6.85714H1.71429C1.25963 6.85714 0.823593 7.03776 0.502103 7.35925C0.180612 7.68074 0 8.11677 0 8.57143V20.1429C0 22.2362 1.76376 24 3.85714 24H18.4286C20.4967 24 22.2857 22.3281 22.2857 20.2098V8.57143C22.2857 8.11677 22.1051 7.68074 21.7836 7.35925C21.4621 7.03776 21.0261 6.85714 20.5714 6.85714H17.1429ZM1.71429 8.57143L1.71429 20.1429C1.71429 21.2895 2.71053 22.2857 3.85714 22.2857H18.4286C19.6005 22.2857 20.5714 21.3315 20.5714 20.2098V8.57143H1.71429Z" fill="#383838"></path></g></svg></span><span class="cartCountSelector cart-count bag-icon size-1">' + cart.cart.item_count + '</span></span></a>'
        document.querySelector('#cart-count-desktop').innerHTML = html;
        document.querySelectorAll('.header-navigation .cartCountSelector')[1].style.marginTop = "5px";
      }

      if (totalSavedPrice > 0) {
        if (document.querySelector('.td-rebuy__total-saved')) {
          document.querySelector('.td-rebuy__total-saved').innerHTML =
            'You saved $' + Number(totalSavedPrice).toFixed(2) + '!'
          document.querySelector(
            '.rebuy-cart__flyout-subtotal'
          ).style.marginBottom = '0'
        } else {
          let totalSaved = document.createElement('div')
          totalSaved.classList.add('td-rebuy__total-saved')
          totalSaved.innerHTML =
            'You saved $' + Number(totalSavedPrice).toFixed(2) + '!'
          document.querySelector(
            '.rebuy-cart__flyout-subtotal'
          ).style.marginBottom = '0'
          insertAfter(
            totalSaved,
            document.querySelector('.rebuy-cart__flyout-subtotal')
          )
        }
      } else {
        if (document.querySelector('.rebuy-cart__flyout-empty-cart') && document.querySelector('.td-empty-form')) {
          document.querySelector('.rebuy-cart__flyout-empty-cart').innerHTML = document.querySelector('.td-empty-form').innerHTML;
        }
      }
    }, 100)
  })

  setTimeout(() => {
    if (document.getElementById('cart-count-desktop')) {
      document.getElementById('cart-count-desktop').addEventListener('click', () => {
        window.Rebuy.SmartCart.show();
      })
    }

    if (document.getElementById('cart-count-mobile')) {
      document.getElementById('cart-count-mobile').addEventListener('click', () => {
        window.Rebuy.SmartCart.show();
      })
    }

    if (document.querySelectorAll('.cart-count-mobile').length > 0) {
      document.querySelectorAll('.cart-count-mobile').forEach(cartItem => {
        cartItem.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.Rebuy.SmartCart.show();
        })
      })
    }
  }, 5000);

  //--
  // Mobile mega menu
  let mobile_menu = document.querySelector('.header-mobile-buttons-wrapper')
  mobile_menu.querySelectorAll('.has-dropdown').forEach(parent => {
    parent.querySelector('a.parent').addEventListener('click', e => {
      e.preventDefault()
      let submenu = parent.querySelector('ul')
      
      let curHeight = window.getComputedStyle(submenu).getPropertyValue("height")
      submenu.style.height = 'auto';
      let autoHeight = window.getComputedStyle(submenu).getPropertyValue("height")
      submenu.style.height = curHeight;

      submenu.classList.toggle("height-open");
      if(submenu.classList.contains("height-open")){
        submenu.style.height = 'auto'
      }
      else {
        submenu.style.height = '0'
      }
      
    })
  })
})